import React, {FC, useState, useEffect} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import GenericModal from "@irati/ui/src/GenericModal"
import Button from "@irati/ui/src/Button"
import {Card} from "@irati/ui/src/Layout"
import Form from "@irati/ui/src/Form"
import adminTracking from "@irati-tracking/admin"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {Img} from "../styled"
import {StyledCheckbox} from "./styled"
import AbandonModal from "./AbandonModal"

interface Props extends InjectIntl {
  show: boolean
  onClose: () => void
  onNext: () => void
}

const KeyTermsModal: FC<Props> = ({show, onClose, onNext, formatMessage}) => {
  const [termsCheckbox, setTermsCheckbox] = useState<boolean>(false)
  const [showModal, setShowModal] = useState(show)
  const [showAbandonModal, setShowAbandonModal] = useState(false)

  const theme = useTheme()

  const handleKeyTerms = () => {
    setTermsCheckbox(!termsCheckbox)
  }

  const handleContinue = () => {
    adminTracking.hrisUpsellSetup("admin_dysnc_purchase_key_terms", {action: "key_terms"})
    onClose()
    onNext()
  }

  const handleOnReturn = () => {
    setShowAbandonModal(false)
    setShowModal(true)
  }

  const handleOnClose = () => {
    setShowAbandonModal(false)
    onClose()
  }

  const handleOnHide = () => {
    setShowModal(false)
    setShowAbandonModal(true)
  }

  useEffect(() => {
    setShowModal(show)
    setTermsCheckbox(false)
  }, [show])

  return (
    <>
      <GenericModal customWidth={900} hideActions show={showModal} onHide={handleOnHide}>
        <H2 marginBottom={2}>
          <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.step2.title" />
        </H2>
        <Flex flex="1 1 30%" gap={3} marginBottom={2}>
          <Card>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.step2.keyTerms1.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.step2.keyTerms1.body" />
            </Body>
          </Card>
          <Card>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.step2.keyTerms2.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.step2.keyTerms2.body" />
            </Body>
          </Card>
          <Card>
            <Flex justifyContent="center" marginBottom={2}>
              <Img medium src={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.step2.keyTerms3.img"})} />
            </Flex>
            <Body small color={theme.colors.greys.black}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.step2.keyTerms3.body" />
            </Body>
          </Card>
        </Flex>
        <Form>
          <StyledCheckbox name="keyTerms" checked={termsCheckbox} onChange={handleKeyTerms}>
            <Body color={theme.colors.greys.black} display="inline-block">
              <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.step2.termsCheckboxLabel" />
            </Body>
          </StyledCheckbox>
        </Form>
        <Flex justifyContent="flex-end">
          <Flex width="250px">
            <Button primary full disabled={!termsCheckbox} onClick={handleContinue}>
              <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.step2.continue" />
            </Button>
          </Flex>
        </Flex>
      </GenericModal>
      <AbandonModal show={showAbandonModal} upsell onClose={handleOnClose} onReturn={handleOnReturn} />
    </>
  )
}

export default injectIntl(KeyTermsModal)
